import { createSelector } from '@reduxjs/toolkit';

import { ReduxState } from 'redux/root-reducer';

const selectSelf = (state: ReduxState) => state.moderators;

export const selectModerators = createSelector(selectSelf, (state) => state.moderators);
export const selectCurrentModerator = createSelector(selectSelf, (state) => state.currentMod);
export const selectIsCurrentUserAdminStaff = createSelector(
    selectSelf,
    (state) => state.currentMod?.roles.admin || state.currentMod?.roles.staff,
);
